import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/profile',
            name: 'network_profile',
            component: () => import("./views/profile.vue"),
            meta: {
                hasBar: true,
                bottomCutFixed: true,
            }
        },
    ];
};